<template>
  <div id="app">
    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar iconAction="1" :changeurl="changeurl()"></Navbar>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-body">
                <div class="form-row">
                  <svg v-if="isBind === '1'" width="70" height="70" style="margin: auto" viewBox="0 0 70 70" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M35 0.125C15.7344 0.125 0.125 15.875 0.125 35C0.125 54.2656 15.7344 69.875 35 69.875C54.125 69.875 69.875 54.2656 69.875 35C69.875 15.875 54.125 0.125 35 0.125ZM35 65.375C18.2656 65.375 4.625 51.875 4.625 35C4.625 18.4062 18.125 4.625 35 4.625C51.5938 4.625 65.375 18.2656 65.375 35C65.375 51.7344 51.7344 65.375 35 65.375ZM54.8281 26.8438C55.5312 26.1406 55.5312 25.0156 54.8281 24.4531L53.7031 23.1875C53 22.4844 51.875 22.4844 51.3125 23.1875L28.25 45.9688L18.5469 36.2656C17.9844 35.5625 16.8594 35.5625 16.1562 36.2656L15.0312 37.3906C14.3281 38.0938 14.3281 39.0781 15.0312 39.7812L27.125 52.0156C27.6875 52.5781 28.8125 52.5781 29.5156 52.0156L54.8281 26.8438Z"
                        fill="#BAA16F"
                    />
                  </svg>
                  <svg v-else width="72" height="54" style="margin: auto" viewBox="0 0 72 54" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M65.25 0H6.75C2.95312 0 0 3.09375 0 6.75V47.25C0 51.0469 2.95312 54 6.75 54H65.25C68.9062 54 72 51.0469 72 47.25V6.75C72 3.09375 68.9062 0 65.25 0ZM6.75 4.5H65.25C66.375 4.5 67.5 5.625 67.5 6.75V12.6562C64.4062 15.1875 59.9062 18.8438 46.2656 29.6719C43.875 31.6406 39.2344 36.1406 36 36C32.625 36.1406 27.9844 31.6406 25.5938 29.6719C11.9531 18.8438 7.45312 15.1875 4.5 12.6562V6.75C4.5 5.625 5.48438 4.5 6.75 4.5ZM65.25 49.5H6.75C5.48438 49.5 4.5 48.5156 4.5 47.25V18.4219C7.59375 21.0938 12.6562 25.1719 22.7812 33.1875C25.7344 35.5781 30.7969 40.6406 36 40.5C41.0625 40.6406 46.125 35.5781 49.0781 33.1875C59.2031 25.1719 64.2656 21.0938 67.5 18.4219V47.25C67.5 48.5156 66.375 49.5 65.25 49.5Z"
                      fill="#877750"
                    />
                  </svg>
                </div>
                <div v-if="isBind === '1'" class="form-row" style="padding-top: 30px; flex-direction: column">
                  <h3 style="margin: auto">{{ $t("Binding Successful") }} </h3>
                  <p style="margin: auto">{{ $t("Your KLUB 11 and KDP account have been bound.") }}</p>
                </div>
                <div v-else class="form-row" style="padding-top: 30px">
                  <h3 style="margin: auto">{{ $t("Confirm with email") }}</h3>
                </div>
                <div class="form-row" v-if="isBind !== '1'">
                  <p style="
                      margin: auto;
                      padding-top: 10px;
                      padding-bottom: 30px;
                      text-align: center;
                    ">
                    {{ $t("A confirmation has been sent to the email") }}
                    {{ email }}
                    {{
                      $t(
                        "Please click on the link in the email to complete registration"
                      )
                    }}
                  </p>
                </div>
                <div class="form-row" v-if="curbonus != 0" style="padding-top: 30px">
                  <p style="margin: auto; padding-bottom: 20px">
                    {{
                      $t(
                        "The following points will be converted upon successful registration"
                      )
                    }}
                  </p>
                </div>
                <div
                  class="form-row"
                  style="padding-bottom: 30px"
                  v-if="curbonus != 0"
                >
                  <div class="col-5" style="margin: auto; font-size: 24px">
                    <font
                      style="margin: auto; text-align: center"
                      class="textcenter"
                      ><b>{{ curbonus }}</b></font
                    ><font
                      style="margin: auto; text-align: center"
                      class="textcenter"
                      ><b>{{ $t("KLUB Point") }}</b></font
                    >
                  </div>
                  <div class="col-2" style="margin: auto; font-size: 48px">
                    <font style="margin: auto" class="textcenter">&#8594;</font>
                  </div>
                  <div class="col-5" style="margin: auto; font-size: 24px">
                    <font
                      style="margin: auto; text-align: center"
                      class="textcenter"
                      ><b>{{ curbonus }}</b></font
                    ><font
                      style="margin: auto; text-align: center"
                      class="textcenter"
                      ><b>{{ $t("K Point") }}</b></font
                    >
                  </div>
                </div>

                <button class="btn btn-primary col-md-12" @click="backhome()">
                  <span id="loading" ref="loading">{{ $t("Okay") }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<style>
#country_code {
  border: none;
  border-bottom: 1px solid #000000;
}

.textcenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}

.vue-country-select .current .country-code {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      email: null,
      curbonus: 0,
      callbackurl: null,
      isBind: "0",
    };
  },
  created() {
    this.actionSetForceBlock(false);
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.email = window.sessionStorage.getItem("email");
    this.curbonus = window.sessionStorage.getItem("curbonus") ?? 0;
    this.isBind = window.sessionStorage.getItem("binding") ?? "0";
    window.sessionStorage.clear();
    if (this.email == null) {
      window.location.href = "./";
    }
    var char = "";
    var char2 = this.email.indexOf("@");
    for (var i = 1; i < char2; i++) {
      char += "*";
    }
    this.email =
      this.email.slice(0, 1) +
      char +
      this.email.slice(char2, this.email.length);
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),

    backhome() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack({
          url: this.callbackurl,
          success: function () {
            console.log('success')
          },
          fail: function () {
            console.log('fail');
          },
          complete: function () {
            console.log('complete');
          }
        });
      } else if (this.callbackurl != null && this.callbackurl != ""&& this.callbackurl != "null") {
        window.location.href = this.callbackurl;
      } else {
        window.location.href = "./#/";
      }
    },
     changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
  },
};
</script>
